/* eslint-disable */

declare global {
    interface Window {
        helpcrunchSettings: any;
        HelpCrunch: any;
        attachEvent: any;
    }
}

/** підключення нового helpcrunch chat */
export default function useHelpCrunchChatNew(): void {
    if (typeof window === "undefined") {
        console.error("Object window not found");
        return;
    }

    // CrunchSettings
    window.helpcrunchSettings = {
        organization: "breezy",
        appId: "6524309d-1cdf-4f5c-abc8-49beae6b5bf9",
        showWidget: false, // if  this field is not sent, or is sent as true, showChatWidget will automatically run after the init
        openWidget: false,
    };

    // initCrunch
    (function (w, d) {
        const hS = w.helpcrunchSettings;
        if (!hS || !hS.organization) {
            return;
        }
        const widgetSrc = "https://embed.helpcrunch.com/sdk.js";
        w.HelpCrunch = function () {
            w.HelpCrunch.q.push(arguments);
        };
        w.HelpCrunch.q = [];
        function r() {
            if (d.querySelector('script[src="' + widgetSrc + '"')) {
                return;
            }
            const s = d.createElement("script");
            s.async = true;
            s.type = "text/javascript";
            s.src = widgetSrc;
            (d.body || d.head).appendChild(s);
        }
        if (d.readyState === "complete" || hS.loadImmediately) {
            r();
        } else if (w.attachEvent) {
            w.attachEvent("onload", r);
        } else {
            w.addEventListener("load", r, false);
        }
    })(window, document);
}
